import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, enumField } from './util';
import { VolleyballStatisticTypes } from './tournament';

export enum VolleyballGameTypes {
  best_of_five = 1,
  best_of_three,
  to_sets_count
}

@ModelInstance({
  mappingFields: {
    game_type: 'gameType',
    periods_count: 'periodsCount',
    timeout_count: 'timeoutCount',
    timeout_time: 'timeoutTime',
    substitute_count: 'substituteCount',
    score_in_set: 'scoreInSet',
    score_in_last_set: 'scoreInLastSet',
    statistic_type: 'statisticType',
    libero_user_ids: 'liberoUserIds',
    max_game_players: 'maxGamePlayers',
  },
  relation: {
    gameType: enumField(VolleyballGameTypes),
    statisticType: enumField(VolleyballStatisticTypes),
  }
})
export class VolleyballGameConfig extends BaseModel {
  gameType: VolleyballGameTypes;
  periodsCount: number;
  timeoutCount: number;
  timeoutTime: number;
  substituteCount: number;
  scoreInSet: number;
  scoreInLastSet: number;
  statisticType: VolleyballStatisticTypes;
  liberoUserIds: number[];
  maxGamePlayers: number;

  get setsCount(): number {
    if (this.gameType === VolleyballGameTypes.to_sets_count) {
      return this.periodsCount ? this.periodsCount : 3;
    } else {
      return this.gameType === VolleyballGameTypes.best_of_three ? 3 : 5;
    }
  }

  getSetMaxScore(set: number) {
    return set === this.setsCount ? this.scoreInLastSet : this.scoreInSet;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
